module.exports = __webpack_public_path__ + "img/pwa-install-popup-btn.06a6a1c2.png";